import { render, staticRenderFns } from "./CallToActionButton.vue?vue&type=template&id=79c6c4fd&scoped=true&"
import script from "./CallToActionButton.vue?vue&type=script&lang=js&"
export * from "./CallToActionButton.vue?vue&type=script&lang=js&"
import style0 from "./CallToActionButton.vue?vue&type=style&index=0&id=79c6c4fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c6c4fd",
  null
  
)

export default component.exports